import { apiService } from './apiService'
import { User, UserFilters, PaginatedResponse, ExportRequest } from '@types'

export const userService = {
  // 获取用户列表
  async getUsers(filters: UserFilters): Promise<PaginatedResponse<User>> {
    const params = new URLSearchParams()

    if (filters.status && filters.status !== 'all') {
      params.append('status', filters.status)
    }
    if (filters.city) {
      params.append('city', filters.city)
    }
    if (filters.province) {
      params.append('province', filters.province)
    }
    if (filters.startDate) {
      params.append('startDate', filters.startDate)
    }
    if (filters.endDate) {
      params.append('endDate', filters.endDate)
    }
    if (filters.page) {
      params.append('page', filters.page.toString())
    }
    if (filters.pageSize) {
      params.append('pageSize', filters.pageSize.toString())
    }
    if (filters.search) {
      params.append('search', filters.search)
    }

    return apiService.get<PaginatedResponse<User>>(`/users?${params.toString()}`)
  },

  // 获取用户详情
  async getUserDetail(id: string): Promise<User> {
    return apiService.get<User>(`/users/${id}`)
  },

  // 更新用户状态
  async updateUserStatus(id: string, status: 'active' | 'inactive' | 'banned'): Promise<void> {
    return apiService.put(`/users/${id}/status`, { status })
  },

  // 更新用户信息
  async updateUser(id: string, data: Partial<User>): Promise<User> {
    return apiService.put<User>(`/users/${id}`, data)
  },

  // 获取用户统计
  async getUserStatistics(filters: UserFilters): Promise<any> {
    const params = new URLSearchParams()
    
    if (filters.status && filters.status !== 'all') {
      params.append('status', filters.status)
    }
    if (filters.city) {
      params.append('city', filters.city)
    }
    if (filters.province) {
      params.append('province', filters.province)
    }
    if (filters.startDate) {
      params.append('startDate', filters.startDate)
    }
    if (filters.endDate) {
      params.append('endDate', filters.endDate)
    }
    
    return apiService.get(`/users/statistics?${params.toString()}`)
  },

  // 导出用户数据（CSV）
  async exportUsers(filters: UserFilters, format: 'excel' | 'csv' | 'pdf'): Promise<void> {
    const exportRequest: ExportRequest = {
      filters,
      format,
      fields: [
        'id',
        'nickname',
        'phone',
        'gender',
        'city',
        'province',
        'country',
        'status',
        'createdAt',
      ],
    }
    const name = `users_${new Date().toISOString().split('T')[0]}.csv`
    return apiService.postDownload('/users/export', exportRequest, name)
  },

  // 批量更新用户状态
  async batchUpdateStatus(ids: string[], status: 'active' | 'inactive' | 'banned'): Promise<void> {
    return apiService.put('/users/batch/status', { ids, status })
  },

  // 获取用户增长趋势
  async getUserGrowthTrend(timeRange: string = '30d'): Promise<any> {
    return apiService.get(`/users/growth-trend?range=${timeRange}`)
  },

  // 获取用户地区分布
  async getUserRegionDistribution(): Promise<any> {
    return apiService.get('/users/region-distribution')
  },

  // 获取用户活跃度统计
  async getUserActivityStats(): Promise<any> {
    return apiService.get('/users/activity-stats')
  },

  // 获取用户订阅统计
  async getUserSubscriptionStats(userId: string): Promise<any> {
    return apiService.get(`/users/${userId}/subscription-stats`)
  },

  // 获取用户行为分析
  async getUserBehaviorAnalysis(userId: string): Promise<any> {
    return apiService.get(`/users/${userId}/behavior-analysis`)
  },
}



